import { gql } from '@apollo/client';

export const CREATE_DELIVERY = gql`
  mutation createDelivery(
      $date: String!
    ) {
      createDelivery(
        delivery: {
          date: $date
        }
      ) {
        id,
        created_at
      }
    }
`;
